// 演示数据：虚构明星故事与匿名讨论素材（非真实新闻）
export const siteMeta = {
  name: "明星爆料",
  slogan: "全网八卦 · 一站吃透",
  desc: "聚合微博、豆瓣、知乎、公众号、天涯、贴吧六平台高能爆料，追踪娱乐圈每一个瓜的完整脉络与最新进展。",
  email: "hello@mxxb.example.cn",
};

export const platforms = [
  { slug: "weibo", name: "微博热搜", short: "微博", icon: "ri-fire-fill", blurb: "实时的热搜榜与千万转发，圈内动向第一落点。" },
  { slug: "douban", name: "豆瓣小组", short: "豆瓣", icon: "ri-group-fill", blurb: "八组鹅组深扒帖，理时间线挖蛛丝马迹的硬核现场。" },
  { slug: "zhihu", name: "知乎深扒", short: "知乎", icon: "ri-question-answer-fill", blurb: "高赞长答与业内视角，把事件掰开揉碎给你讲清楚。" },
  { slug: "wechat", name: "公众号长文", short: "公众号", icon: "ri-article-fill", blurb: "行业号与娱评号的长篇复盘，后置真相与幕后拆解。" },
  { slug: "tianya", name: "天涯神帖", short: "天涯", icon: "ri-archive-fill", blurb: "考古级神帖回炉，经典旧瓜与爆料叠楼的元老阵地。" },
  { slug: "tieba", name: "贴吧讨论", short: "贴吧", icon: "ri-chat-3-fill", blurb: "粉丝与路人混战的第一现场，路透图与热梗集散地。" },
];

export const faqs = [
  { q: "明星爆料的内容来源可靠吗？", a: "我们只做“聚合转述”，每条资讯都会标注来源平台与作者署名，并区分“实锤”“传闻”“网友分析”三种可信度标签。是否为真需以当事人与官方声明为准，我们不生产未经核实的主观定论。" },
  { q: "会不会侵犯明星的隐私？", a: "平台坚持只转载已在公开社交账号、公开媒体报道与可公开讨论范围内的信息，不做跟拍、不泄露住址电话等私密信息，并设内容举报入口及时下线越界内容。" },
  { q: "为什么同一个瓜不同平台说法不一样？", a: "不同平台的信息层级、讨论语境与消息源头本就不同——微博拼热度、豆瓣理时间线、知乎讲逻辑、公众号做复盘。我们鼓励交叉比对，信息越多元越接近真相。" },
  { q: "如何订阅或投稿一条新瓜？", a: "您可通过站内联系表单投递线索或纠错，也可以在详情页使用“分享链接”把正在追的瓜发给朋友。线索一旦采纳，会以投稿人昵称署名。" },
  { q: "为什么需要定期刷新追更？", a: "娱乐圈瓜往往有续集，当事人声明、后续回应、平台删帖都会改变事件走向。我们会为每条追踪中事件持续更新“进展时间线”，建议收藏关注以便随时回来补课。" },
];

export const trending = [
  { title: "姜以宁新剧番位疑云升级，片方深夜两度改口径", heat: "986万", platform: "微博热搜", trend: "up" },
  { title: "林叙白被拍到与神秘女子同行，网友扒出同款手链", heat: "754万", platform: "豆瓣小组", trend: "up" },
  { title: "知乎万字长文复盘：顶流塌房前的23个预警信号", heat: "612万", platform: "知乎深扒", trend: "up" },
  { title: "综艺未播先撕，沈聿工作室发布严正声明", heat: "528万", platform: "公众号长文", trend: "up" },
  { title: "天涯考古帖复活：十年前的神预言竟逐一应验", heat: "471万", platform: "天涯神帖", trend: "up" },
  { title: "贴吧路透流出庆功宴图，苏打疑似官宣在即", heat: "389万", platform: "贴吧讨论", trend: "up" },
  { title: "顾之遥演唱会「假唱」风波，专业鉴定博主下场", heat: "342万", platform: "微博热搜", trend: "down" },
  { title: "圈内人匿名爆料：某S级项目已空降男主", heat: "297万", platform: "公众号长文", trend: "up" },
  { title: "闻溪造型翻车冲上热一，造型师凌晨删博", heat: "231万", platform: "豆瓣小组", trend: "down" },
  { title: "许照与经纪公司合约到期，去向成谜", heat: "184万", platform: "贴吧讨论", trend: "up" },
];

export const articles = [
  {
    id: "gua-001",
    title: "姜以宁新剧番位疑云升级：片方深夜两度改口径，究竟是压番还是加戏？",
    summary: "从开机官宣的一番名单，到今晚海报的排位变化，再到片方凌晨两点删改微博，番位问题一夜之间连换三版说法，网友直呼这瓜还能再养养。",
    cover: "https://readdy.ai/api/search-image?query=dark%20moody%20backstage%20of%20a%20drama%20studio%20with%20spotlights%20and%20film%20clapperboard%2C%20cinematic%20warm%20vermillion%20and%20amber%20lighting%2C%20editorial%20entertainment%20news%20style%2C%20atmospheric%20and%20mysterious%2C%20high%20contrast%20shadows&width=900&height=560&seq=cover-gua001&orientation=landscape",
    source: "weibo",
    sourceName: "微博热搜",
    category: "番位",
    tags: ["番位之争", "新剧", "片方声明", "时间线"],
    author: "追更酱",
    time: "2小时前",
    views: "86万",
    likes: 12840,
    comments: 3210,
    top: true,
    hot: true,
    featured: true,
    timeline: [
      { t: "20:11", d: "片方首发开机海报，姜以宁位列一番名单首位。" },
      { t: "23:46", d: "宣传口径将男主演名字前移，评论区开始发酵。" },
      { t: "02:05", d: "片方重新编辑微博，番位再度调整并删除部分评论。" },
      { t: "今晨", d: "工作室转发声明称“尊重合同约定”，事件仍在演进。" },
    ],
    paragraphs: [
      "一部备受期待的都市职场剧，本应因为阵容豪华而备受关注，却因为一张海报的位置排布，让热搜榜在深夜反复易主。事情要从开机官宣说起——剧组发布定妆海报时，姜以宁的名字排在领衔主演的第一位，粉丝与路人原本也都默认这是一番女主配置。",
      "转折出现在深夜的宣传活动上。片方在宣传物料中悄悄调整了演员的排位顺序，把男主演的名字提前到姜以宁之前。敏锐的粉丝第一时间截图留存，并@片方质问：明明开机时白纸黑字的番位，怎么说变就变？讨论在短短一小时内从评论区扩散到各大平台。",
      "更耐人寻味的是片方接下来的操作。凌晨两点左右，片方工作人员删除了争议文案并重新编辑发布，新的版本将两位主演并列排开，试图用“并列一番”的说法安抚双方。可网友并不买账，因为截图对比显示前后两版存在明显差别，所谓“从未改口”的说法被当场打脸。",
      "截至目前，姜以宁工作室仅转发了一则措辞克制的声明，强调“一切以合同约定为准”，没有正面回应番位变化。而豆瓣小组已经有人扒出制作公司过往项目的宣传惯例，认为这并非第一次出现“先画饼、后调整”的操作。",
      "业内人士私下分析，番位之争本质是话语权与后续资源博弈的缩影：海报排位、宣传顺序、发布会站位甚至采访名单，背后都藏着团队对“红不红”最敏感的判断。这一轮口水仗究竟会以谁的让步收场，恐怕还要等官方更正式的回应，而这个瓜，大概率还有续集。",
    ],
  },
  {
    id: "gua-002",
    title: "林叙白被拍到与神秘女子同行，网友顺藤扒出同款手链",
    summary: "一组深夜同行照点燃讨论，眼尖网友在两人手腕上发现了同款编织手链，恋情猜测瞬间冲上话题榜，工作室至今保持沉默。",
    cover: "https://readdy.ai/api/search-image?query=two%20silhouettes%20walking%20together%20on%20a%20rainy%20city%20street%20at%20night%2C%20soft%20warm%20streetlight%20glow%2C%20candid%20paparazzi%20style%2C%20editorial%20and%20mysterious%2C%20warm%20orange%20tones%2C%20blurred%20background%20bokeh&width=900&height=560&seq=cover-gua002&orientation=landscape",
    source: "douban",
    sourceName: "豆瓣小组",
    category: "恋情",
    tags: ["恋情", "深夜同行", "同款手链", "偶遇"],
    author: "吃瓜研究所",
    time: "5小时前",
    views: "54万",
    likes: 8420,
    comments: 2215,
    hot: true,
    featured: false,
    paragraphs: [
      "狗仔镜头下的深夜街拍，又一次让林叙白的名字登上热搜。画面里，裹得严严实实的男子与一位高挑女子并肩走在霓虹灯下的街道，两人步伐放松、距离很近，偶尔低头交谈，看起来并不设防。",
      "真正让事件从“普通偶遇”升级成“恋情实锤疑云”的，是网友的无心之举。有人把照片放大后，发现女方手腕上缠绕着一条红黑相间的编织手链——而就在半个月前，林叙白参加品牌活动时，也曾被拍到同款手链出现在他的袖口。同款单品在同一时间段内同时出现在两人身上，讨论由此一发不可收拾。",
      "豆瓣小组的帖子更新得飞快：有人翻出女方此前晒过的咖啡杯、画室地址等生活碎片，试图拼出她的身份；也有人质疑手链本就是品牌方大批量投放的赠品，撞款并不能说明任何问题。两边各执一词，评论区吵成了一锅粥。",
      "截至发稿，林叙白工作室仍未对恋情传闻作出任何回应，这种“不否认也不承认”的态度，让事件的热度进一步攀升。有经验的粉丝分析，若真是乌龙，通常会有团队第一时间辟谣；迟迟不表态，往往意味着事态正在内部评估，瓜大概率还有得啃。",
    ],
  },
  {
    id: "gua-003",
    title: "万字复盘：顶流在“塌房”前，究竟埋下了哪些预警信号？",
    summary: "知乎高赞答主从时间、细节、资源三个维度，复盘了多位翻车艺人的共同轨迹：辉煌顶点总是离悬崖最近。",
    cover: "https://readdy.ai/api/search-image?query=ancient%20magnifying%20glass%20over%20newspaper%20clippings%20and%20timeline%20photos%20on%20a%20desk%2C%20detective%20investigation%20mood%2C%20warm%20desk%20lamp%20light%2C%20editorial%20documentary%20style%2C%20shallow%20depth%20of%20field%2C%20amber%20and%20brown%20tones&width=900&height=560&seq=cover-gua003&orientation=landscape",
    source: "zhihu",
    sourceName: "知乎深扒",
    category: "争议",
    tags: ["深度复盘", "业内分析", "塌房预警", "长文"],
    author: "圈内观察者",
    time: "昨天",
    views: "122万",
    likes: 25130,
    comments: 5140,
    hot: true,
    featured: true,
    paragraphs: [
      "娱乐圈的每次翻车，事后回看都并非毫无征兆。这篇近万字的知乎高赞长文，试图从公开信息中打捞那些被热闹掩盖的细节，复盘几位流量艺人从巅峰到坠落前的共性轨迹，被网友称作“塌房预警教科书”。",
      "答主总结了三个维度的信号。其一是时间维度：几乎所有事件的集中爆发，都发生在艺人资源最密集、口碑最好的窗口期——因为此时媒体聚光灯最亮，任何越界行为都会被无限放大；其二是细节维度：翻车往往不是从大错开始，而是从某次被忽视的小冒犯、小隐瞒逐渐累积，最终被一条旧帖或一张旧图引爆；其三是资源维度：那些突然空降顶级资源、连跳几级的艺人，若实力与待遇不匹配，最容易被“捧杀”，成为资本撤场后的牺牲品。",
      "文中反复强调一个观点：所谓预警信号，与其说是命运的暗示，不如说是长期行为习惯的必然结果。答主写道，娱乐圈真正的分水岭不是红与不红，而是红起来之后是否还记得自己是谁——德不配位，必有灾殃；才不配名，终会反噬。",
      "长文在评论区获得大量共鸣，不少用户现身说法补充案例，也有人提醒“复盘不等于审判”，在当事人尚未被官方定性前，不应仅凭事后推导给任何人扣帽子。这种理性讨论的延伸，也让这则长文比单纯吃瓜多了几分深度。",
    ],
  },
  {
    id: "gua-004",
    title: "综艺未播先撕？沈聿工作室声明措辞火药味十足",
    summary: "一档刚官宣的旅行真人秀尚未开录，网传人员变动就让工作室连夜发声，声明中一句“尊重但不纵容”引发多方解读。",
    cover: "https://readdy.ai/api/search-image?query=television%20studio%20with%20bright%20stage%20lights%20and%20microphones%2C%20press%20conference%20table%20with%20name%20cards%2C%20editorial%20news%20photo%20style%2C%20warm%20stage%20lighting%2C%20slight%20drama%20and%20tension%20mood%2C%20golden%20and%20vermilion%20tones&width=900&height=560&seq=cover-gua004&orientation=landscape",
    source: "wechat",
    sourceName: "公众号长文",
    category: "综艺",
    tags: ["真人秀", "声明", "人员变动", "撕番"],
    author: "综艺前线",
    time: "昨天",
    views: "43万",
    likes: 6120,
    comments: 1890,
    hot: false,
    featured: false,
    paragraphs: [
      "一档备受期待的户外旅行真人秀刚官宣常驻嘉宾名单，还没来得及开录，就被一则网传“某嘉宾临时退出、节目组紧急换人”的消息搅得天翻地覆。消息发酵当晚，沈聿工作室的一纸声明直接把热度顶上了热搜。",
      "声明全文不过百余字，字面意思克制，潜台词却火药味十足。最关键的一句是“尊重节目组安排，但绝不纵容损害艺人形象的行为”，被网友逐字拆解：什么算是“纵容”？又是什么行为损害了艺人形象？声明没有点名，却处处让人对号入座，评论区瞬间分成两派。",
      "粉丝阵营认为，这是工作室在替沈聿争取公平待遇，警告有人利用节目剪辑或临时换人做文章；吃瓜路人则调侃，声明越是含含糊糊，越说明双方还没谈拢，真正的博弈恐怕在桌子底下。公众号文章引用业内人士的说法，称这类“未播先撕”如今已成综艺宣传的常见戏码——热度有了，但口碑透支的风险也随之而来。",
      "目前节目组官方尚未给出最新常驻名单，沈聿团队也没有进一步回应。究竟是节目宣发为了造势的自导自演，还是嘉宾之间真的谈崩，只有等节目开录后的路透才能见分晓。对于追综艺的人来说，这个瓜也许比节目本身还好看。",
    ],
  },
  {
    id: "gua-005",
    title: "天涯十年前神帖被挖出，预言逐一应验，网友惊呼“太玄了”",
    summary: "一篇尘封多年的旧帖因近期事件重新被顶上首页，当年楼主随口写下的预测竟与今日发展高度吻合，考古玩家集体膜拜。",
    cover: "https://readdy.ai/api/search-image?query=vintage%20old%20blog%20forum%20thread%20on%20a%20retro%20computer%20screen%2C%20dusty%20archival%20atmosphere%2C%20warm%20sepia%20toned%2C%20nostalgic%20early%20internet%20mood%2C%20editorial%20documentary%2C%20grainy%20texture&width=900&height=560&seq=cover-gua005&orientation=landscape",
    source: "tianya",
    sourceName: "天涯神帖",
    category: "考古",
    tags: ["天涯考古", "神预言", "旧帖回炉", "复盘"],
    author: "天涯考古队",
    time: "3天前",
    views: "68万",
    likes: 10230,
    comments: 2870,
    featured: false,
    paragraphs: [
      "互联网考古的风，这次吹到了天涯。一篇发布于十年前的旧帖，因为近期某位艺人的接连新闻被网友重新挖出，帖子里楼主当年随口分析的一段话，竟与今天的实际情况高度吻合，帖子一夜之间被顶上千层回复。",
      "原帖其实写得相当克制。楼主在十年前就注意到某位新人“资源异常集中却几乎没有磨砺期”，于是预言这种“被资本硬捧上去的流量，根基不稳，未来恐怕有反复”。当时的评论区大多一笑而过，觉得不过是楼主眼红；可十年过去，这位艺人的发展轨迹几乎照着预言发展，让无数人倒吸一口凉气。",
      "考古玩家们随即展开了地毯式翻找，把楼主当年的其他发言也一并扒出，发现这位楼主对娱乐圈“资源—实力—口碑”三角关系的判断相当清醒，绝非信口开河。一时间“天涯神帖再出山”成了热梗，甚至有年轻人专门注册账号去围观当年的盛况。",
      "当然，也有理性网友提醒，所谓“预言应验”很大程度存在幸存者偏差——当年类似的帖子成百上千，恰好命中的那一篇才会被考古放大。但无论如何，这篇神帖的回归，让不少老网民重新怀念起那个帖子质量更高、讨论更认真的互联网年代，也成了近期最出圈的“怀旧瓜”。",
    ],
  },
  {
    id: "gua-006",
    title: "贴吧流出庆功宴路透，苏打现场疑似回应“官宣在即”",
    summary: "一张模糊的庆功宴合影点燃粉丝圈，席间一句听不清的话被反复放大，路人纷纷猜测苏打好事将近。",
    cover: "https://readdy.ai/api/search-image?query=celebration%20dinner%20banquet%20table%20with%20warm%20candles%20and%20sparkling%20glasses%2C%20toast%20moment%2C%20intimate%20warm%20festive%20atmosphere%2C%20candid%20photography%2C%20golden%20amber%20glow%2C%20editorial%20lifestyle%2C%20blurred%20guests%20background&width=900&height=560&seq=cover-gua006&orientation=landscape",
    source: "tieba",
    sourceName: "贴吧讨论",
    category: "恋情",
    tags: ["庆功宴", "路透", "官宣", "粉丝圈"],
    author: "吧友十三妹",
    time: "2天前",
    views: "39万",
    likes: 5310,
    comments: 1670,
    paragraphs: [
      "一张画质模糊的手机路透图，把粉丝圈搅得天翻地覆。图片拍摄于某剧组杀青庆功宴现场，主角苏打正举着酒杯与人交谈，而配文那句模棱两可的“看他说得那么开心，怕不是好事将近”，成了点燃讨论的第一根火柴。",
      "贴吧楼主自称是现场工作人员的家属，只发了图不愿多说，越是语焉不详越是吊人胃口。评论区迅速分成“成真派”与“辟谣派”：前者翻出苏打近期状态极好、频繁出入某地，认定恋情修成正果；后者则搬出“剧组杀青本就开心”的反驳，提醒大家别把庆功宴当结婚现场。",
      "话题很快溢出贴吧，蔓延到微博与豆瓣。苏打的粉丝组织反应尤其激烈，连夜在超话发帖，一边要求删帖护隐私，一边给不明真相的路人科普“这只是普通同事聚餐”。但越是急着澄清，越有人觉得“此地无银三百两”。",
      "截至目前，苏打及其团队对“官宣在即”的说法没有任何回应。从娱乐圈过往经验看，所谓“好事”往往在官方未松口前都只是猜测——可反过来，真正的喜讯又总是先被这样的路透泄了底。这个瓜是真是假，恐怕要等当事人自己揭晓答案。",
    ],
  },
  {
    id: "gua-007",
    title: "顾之遥演唱会假唱疑云，专业鉴定博主用波形图下场开撕",
    summary: "一场演唱会片段引发真假唱之争，音乐博主扒出波形异常，粉丝与黑粉各执一词，音源版权方也被卷入。",
    cover: "https://readdy.ai/api/search-image?query=concert%20stage%20with%20singer%20silhouette%20holding%20microphone%20under%20colored%20spotlights%2C%20sound%20waveform%20hologram%20overlay%20concept%2C%20dramatic%20warm%20red%20and%20gold%20lighting%2C%20editorial%20music%20news%2C%20mysterious%20atmosphere&width=900&height=560&seq=cover-gua007&orientation=landscape",
    source: "weibo",
    sourceName: "微博热搜",
    category: "争议",
    tags: ["演唱会", "假唱风波", "鉴定", "音综"],
    author: "波形局",
    time: "4天前",
    views: "91万",
    likes: 15400,
    comments: 4020,
    featured: false,
    paragraphs: [
      "演唱会市场火热，现场演唱的真伪也成了检验歌手成色的试金石。最近，顾之遥的一场万人演唱会片段在网上流传，观众席有人拍下副歌部分她口型与声音几乎“严丝合缝”的画面，随即被质疑为对口型假唱，话题冲上热搜。",
      "争论在白热化阶段迎来了一位重量级选手——一位以做频谱波形分析著称的音乐博主下场。他调取现场录制的多段音频进行比对，指出其中某个高音段落的波形存在“过分干净、几乎无现场环境噪”的异常，与真正现场人声的特征不符，据此判断该段落使用了预录音源。",
      "这份“技术鉴定”一出，粉丝与黑粉立刻进入混战。粉丝从音源版权归属切入，反驳说高音本就是后期精修版，现场通过设备叠加音效并非罕见操作，质疑博主“用录音室音频对比现场是耍流氓”；反对者则晒出博主过往多次成功“打假”的战绩，认为波形不会说谎。",
      "面对越来越大的舆论，音源版权方深夜发布说明，确认该曲目官方版本为录音室录制，但未直接回应现场是否假唱。顾之遥本人尚未发声，主办方表示将配合核实。可以预见，围绕“现场真唱还是技术辅助”的争论还会持续——而真正清醒的网友已经明白，这场风波考验的远不止嗓音，还有歌手与团队面对质疑的态度。",
    ],
  },
  {
    id: "gua-008",
    title: "圈内人匿名爆料：某S级古装项目男主已空降，原定人选被临时顶替",
    summary: "一条匿名投稿搅动影视圈，称筹备三年的S级古装剧临阵换角，原定男主被空降男星顶替，各方评论区吵成一团。",
    cover: "https://readdy.ai/api/search-image?query=ancient%20chinese%20costume%20drama%20set%20with%20ornate%20palace%20architecture%20and%20red%20lanterns%2C%20director%20chair%20and%20film%20camera%20on%20set%2C%20warm%20golden%20and%20vermilion%20tones%2C%20editorial%20behind%20the%20scenes%2C%20cinematic%20dramatic%20lighting&width=900&height=560&seq=cover-gua008&orientation=landscape",
    source: "wechat",
    sourceName: "公众号长文",
    category: "影视",
    tags: ["S级项目", "空降", "换角", "古装"],
    author: "选角观察",
    time: "5天前",
    views: "58万",
    likes: 9230,
    comments: 3150,
    paragraphs: [
      "影视圈的选角风波，往往比戏本身还精彩。最近一则匿名行业投稿在网上疯传，称某筹备已达三年的S级古装权谋剧，男主角色在开机前三个月被临时空降的新人顶替，原定人选团队“至今没有收到任何解释”。",
      "投稿没有点名，却给出了足够多的“可对号入座”的线索：双男主、权谋题材、定级S+、男主此前演过同类型爆剧。这些关键词一出，网友立刻开始拉名单，多位当红男星的名字在评论区被反复提及，各自的粉丝也忙着“自证清白”、互泼脏水。",
      "公众号长文顺着投稿往下扒，梳理出这类“临阵换角”背后的行业逻辑：资本方更看重演员当下的流量与带货能力，而不是与角色的匹配度；一旦有更“划算”的人选出现，前期定好的阵容说变就能变。文中引述一位制片人的话：在开机前，一切名单都只是意向，真正的定局要等官宣那一刻。",
      "更有意思的是后续。投稿发酵后，多个疑似原定人选的粉丝团纷纷向自家工作室求证，得到的答复都是“一切以官方为准”——这种滴水不漏的回应，反而让瓜显得愈发真实。至于那位“空降男主”究竟是谁，恐怕要等剧组官宣阵容，这场迷雾才会散开。",
    ],
  },
  {
    id: "gua-009",
    title: "闻溪红毯造型翻车冲上热一，造型师凌晨删博疑似闹掰",
    summary: "一套被吐槽“用力过猛”的造型让闻溪登上热搜，造型师随后删光动态，双方合作是否终结引发猜测。",
    cover: "https://readdy.ai/api/search-image?query=red%20carpet%20event%20with%20fashionable%20gown%20on%20a%20figure%2C%20flashing%20cameras%20and%20spotlights%2C%20dramatic%20warm%20glamour%20lighting%2C%20editorial%20fashion%20photography%2C%20golden%20and%20crimson%20tones%2C%20glamorous%20atmosphere&width=900&height=560&seq=cover-gua009&orientation=landscape",
    source: "douban",
    sourceName: "豆瓣小组",
    category: "造型",
    tags: ["红毯", "造型翻车", "造型师", "撕破脸"],
    author: "红毯锐评",
    time: "6天前",
    views: "47万",
    likes: 7310,
    comments: 2430,
    paragraphs: [
      "红毯造型是门玄学，有时候穿对了是封神，穿错了就是灾难。最近一场品牌盛典上，闻溪一套被戏称“把整个花园穿在身上”的夸张礼服没能收获好评，反而因配色杂乱、版型突兀被吐槽“用力过猛”，直接把她送上了热搜第一。",
      "照理说造型翻车只是审美争议，吵几天就过去了。真正把瓜引爆的，是造型师随后的一连串操作：他先是深夜发布长文，字里行间抱怨“审美的锅不该我一个人背”，随后又删光了自己账号上所有与闻溪相关的合作动态，最后甚至连简介里的合作头衔也一并摘除。这一套“删博三连”，被网友解读为双方已彻底闹掰。",
      "豆瓣小组的帖子火速分析两人“分道扬镳”的蛛丝马迹：有人发现造型师此前的合作文案全部清空，有人翻出闻溪工作室的红毯感谢名单里已悄悄删掉了他的名字。嘴上什么都没说，行为却说明了一切。",
      "面对外界铺天盖地的猜测，闻溪工作室至今没有正面回应，只发了一张她在后台补妆的照片，配文“重新出发”。这短短四个字被各路解读，有人说是暗示换造型师，有人说是单纯安抚粉丝。无论如何，这场“造型师与艺人”的职场宫斗，已经成了比红毯本身更受关注的话题。",
    ],
  },
  {
    id: "gua-010",
    title: "许照与老东家合约到期，去向成谜，三家公司深夜被爆抢人",
    summary: "许照合约到期的消息刚被确认，就有圈内人称三家公司同时抛出橄榄枝，续约留任还是另立门户引发热议。",
    cover: "https://readdy.ai/api/search-image?query=modern%20office%20skyline%20at%20dusk%20with%20silhouette%20of%20a%20person%20looking%20out%20window%2C%20decision%20making%20mood%2C%20warm%20amber%20twilight%20and%20city%20lights%2C%20editorial%20cinematic%2C%20thoughtful%20atmosphere&width=900&height=560&seq=cover-gua010&orientation=landscape",
    source: "tieba",
    sourceName: "贴吧讨论",
    category: "合约",
    tags: ["合约到期", "去留", "经纪公司", "抢人"],
    author: "吧主小许",
    time: "1周前",
    views: "33万",
    likes: 4890,
    comments: 1450,
    paragraphs: [
      "演员许照与老东家五年合约到期的消息，本是在粉丝内部流传的小道消息，直到一条匿名的行业帖把它推上台面：帖子里言之凿凿地称，已有三家公司于同一晚向许照团队发出洽谈邀约，一场无声的“抢人大战”已经悄然开打。",
      "老东家这些年对许照的资源投入有目共睹，从都市剧配角一路捧到正剧男主，双方感情牌打得相当扎实，不少老粉因此笃定他会“知恩图报”选择续约。但反对的声音同样有力：许照近年口碑与咖位齐升，若继续留在老东家，可能受限于既有排期与旧资源绑定，另寻更能背书的主流平台才是更聪明的选择。",
      "贴吧里关于他去向的猜测五花八门：有人说他会被某家头部公司重金挖走成立个人工作室，有人说他会效仿前辈与老东家合资自立门户保持挂靠关系，还有人翻出他近期频繁接触大导演的行程，认定他早已在为新东家铺路。",
      "截至目前，许照本人只在社交平台发了一句模棱两可的“会好好考虑接下来的路”，配上一张剪影照，评论区瞬间涌入上万条留言，有鼓励、有催促、也有看热闹。合约去留本是个人职业选择，但在粉丝与路人的见证下，这场“谈判”的每一帧都被无限放大，最终花落谁家，还得等官宣。",
    ],
  },
  {
    id: "gua-011",
    title: "梁月新剧「番位平番」官宣海报被指暗藏玄机，文案细节出卖谁",
    summary: "一部双主演新剧官宣平番，可海报中名字的细微位置与一句宣传语，让网友怀疑平番只是表面文章。",
    cover: "https://readdy.ai/api/search-image?query=elegant%20film%20poster%20with%20two%20famous%20silhouettes%20and%20large%20title%20text%20on%20a%20warm%20backdrop%2C%20dramatic%20spotlight%2C%20cinematic%20poster%20design%2C%20golden%20and%20crimson%20editorial%20style%2C%20sophisticated%20layout&width=900&height=560&seq=cover-gua011&orientation=landscape",
    source: "zhihu",
    sourceName: "知乎深扒",
    category: "番位",
    tags: ["平番", "官宣海报", "文案解读", "番位玄学"],
    author: "海报显微镜",
    time: "1周前",
    views: "41万",
    likes: 6880,
    comments: 2010,
    paragraphs: [
      "“平番”二字在娱乐圈向来是门玄学——嘴上说着平等，实则处处暗藏亲疏。最近梁月与搭档官宣新剧，打出“双主演平番”的旗号，可显微镜般的网友还是从海报细节里嗅出了不一样的味道。",
      "首先被质疑的是名字的排布。虽然官方强调两人并列，但细看海报，梁月的名字在视觉重心上略高于另一方，且字号在同等大小下显得稍大一线。设计上的毫厘之差，放在番位敏感的娱乐圈里，足以让评论区吵上三天三夜。",
      "更耐人寻味的是宣传语的用词。官方文案把两人分别描述为“领衔主演”与“特别主演”，看似都是主演，实则“特别”二字在业内常被用来暗指待遇略逊一筹，与所谓“平番”的说法自相矛盾。知乎长答专门逐字拆解了这句文案，指出宣传方大概率是在用文字游戏安抚双方粉丝。",
      "面对质疑，片方只回应了一句“最终呈现以成片为准”，既没否认也没承认，留足了想象空间。有经验的老瓜民感叹，所谓平番之争，本质是艺人与团队在正式开拍前争夺话语权的一次预演——海报上的站位，往往就是接下来一整部剧里资源分配的缩影。至于谁真谁假，镜头会给出答案。",
    ],
  },
  {
    id: "gua-012",
    title: "出道十年再出发：苏打&梁月时隔多年首次同框，cp粉集体过年",
    summary: "一档年代剧的官宣让多年未合作的两位演员再度同框，老cp粉翻出当年的合作旧照，直呼“爷青回”。",
    cover: "https://readdy.ai/api/search-image?query=vintage%20television%20drama%20set%20from%20the%201990s%20era%2C%20two%20actors%20facing%20each%20other%20under%20warm%20stage%20lights%2C%20nostalgic%20warm%20film%20grain%2C%20golden%20hour%20lighting%2C%20editorial%20reunion%20mood%2C%20cinematic&width=900&height=560&seq=cover-gua012&orientation=landscape",
    source: "douban",
    sourceName: "豆瓣小组",
    category: "热播剧",
    tags: ["同框", "cp粉", "年代剧", "爷青回"],
    author: "旧时光放映员",
    time: "1周前",
    views: "36万",
    likes: 5630,
    comments: 1720,
    paragraphs: [
      "互联网的快乐有时候来得猝不及防。一部筹备中的年代剧官宣主演名单，苏打与梁月这两个名字时隔多年再次出现在同一张名单上，消息一出，无数老cp粉连夜翻出两人十年前合作的老剧片段，弹幕被“爷青回”刷了屏。",
      "当年的合作堪称青春记忆里的高光：两人搭档的年代戏创下收视纪录，戏里戏外的默契让cp粉队伍蔚为壮观。此后多年两人各自发展、鲜有交集，重逢的呼声却从未停过，每逢有同框机会的传言，都能在豆瓣掀起一阵讨论热潮。",
      "如今官宣成真，老粉们自然是喜极而泣。有人扒出当年两人合作的幕后采访，感叹“年少的喜欢最是真”；也有人冷静分析，时隔多年再度同框，对两人来说既是情怀加分，也是演技上的再次正面对决，压力与期待并存。",
      "剧组方面透露，这部剧将用更成熟的人物塑造来致敬两人当年的经典角色，而非简单消费情怀。对吃瓜群众而言，这或许不只是又一次“看热闹”，更像是一代观众与青春记忆的和解——无论剧集最终口碑如何，这次时隔多年的同框，本身就足够让人动容。",
    ],
  },
];

export const relatedPick = [
  "gua-001", "gua-003", "gua-004", "gua-007",
];